import React from 'react';
import currencyFormatter from 'currency-formatter';
import ShoppingCartItem from './ShoppingCartItem';
import {connect} from 'react-redux';
import Cookies from 'js-cookie';
import reqwest from 'reqwest';
import swal from 'sweetalert';
import {
  getInitialCart,
  updateQuantity,
  removeFromCart,
  orderCart,
  setSelectedCart
} from '../../actions/actions';
import RenderHTML from '../RenderHTML';
import Selectbox from '../inputs/Selectbox';
import Modal from '../Modal';
import Button from '../inputs/Button';
import Textfield from '../inputs/Textfield';
import Fetch from '../Fetch';
import Checkbox from '../inputs/Checkbox';

class ShoppingCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: window.innerWidth <= 1024 ? true : false,
      requestRTA: false,
      inheritFromFirst: false,
      rta: [],
      rtaLibraries: [],
      rtaFunds: []
    };

    this.rtaConfig =
      window.rtaConfig.find(item => item.username === Cookies.get('username')) || null;
    this._updateQuantity = this._updateQuantity.bind(this);
    this._removeItem = this._removeItem.bind(this);
    this._orderCart = this._orderCart.bind(this);
    this._submitOrderCart = this._submitOrderCart.bind(this);
    this._setSelectedCart = this._setSelectedCart.bind(this);
  }
  componentDidMount() {
    this.props.getInitialCart();
  }
  _toggleShoppingCart = () => {
    this.setState({
      hidden: !this.state.hidden
    });
  };
  _updateQuantity(index, quantity) {
    this.props.updateQuantity(Cookies.get('subaccount'), index, quantity);
  }
  _removeItem(index) {
    this.props.removeFromCart(index);
  }
  _orderCart() {
    if (this.rtaConfig) {
      const librariesRequest = reqwest({
        url: 'https://rta.delbanco.de/proxy/conf/libraries',
        data: {
          apikey: this.rtaConfig.apiKey
        },
        type: 'json',
        method: 'GET',
        crossOrigin: true
      });
      const fundRequest = reqwest({
        url: 'https://rta.delbanco.de/proxy/acq/funds',
        data: {
          limit: 100,
          view: 'full',
          apikey: this.rtaConfig.apiKey
        },
        type: 'json',
        method: 'GET',
        crossOrigin: true
      });
      Promise.all([librariesRequest, fundRequest]).then(([libraries, funds]) => {
        this.setState({
          requestRTA: true,
          rtaLibraries: libraries.library || [],
          rtaFunds: funds.fund || []
        });
      });
    } else {
      this.props.orderCart([], false);
    }
  }
  _submitOrderCart() {
    const additionalAttributes = {
      rta: [],
      ...this.rtaConfig
    };
    let error = false;
    let firstLfd = this.props.items.forEach((item, index) => {
      if (index === 0) {
        firstLfd = item.lfd;
      }
      let rta;
      if (this.state.inheritFromFirst) {
        rta = this.state.rta[firstLfd];
      } else {
        rta = this.state.rta[item.lfd];
      }
      additionalAttributes.rta.push({
        isbn: item.isbn,
        foundCode: rta.foundCode,
        library: rta.library,
        location: rta.location
      });
      if (!rta.foundCode || !rta.library || !rta.location) {
        swal({
          title: 'Please fill out mandatory fields',
          text: `Please fill out all fields marked with *`,
          showConfirmButton: true,
          type: 'error',
          allowOutsideClick: false
        });
        error = true;
      }
    });
    if (!error) {
      this.props.orderCart(additionalAttributes, true);
      this.setState({
        requestRTA: false
      });
    }
  }
  _setSelectedCart(cart) {
    this.props.setSelectedCart(cart);
  }
  render() {
    let totalPrice = 0;
    let currency = '';
    this.props.items.forEach(item => {
      totalPrice = totalPrice + item.vkpr * (item.copy || 1);
      currency = item.kdfw;
    });
    return (
      <div className={`shopping-cart-wrapper ${this.state.hidden ? 'in' : 'out'}`}>
        <button className="shopping-cart-toggler" onClick={this._toggleShoppingCart}>
          <img src="/images/icons/cart.png" aria-hidden="true" alt="Einkaufswagen" />
          {this.props.items && (
            <span className="shopping-cart-count">
              {this.props.items.reduce((sum, item) => {
                return sum + parseInt(item.copy, 10);
              }, 0)}
            </span>
          )}
        </button>
        <div className="shopping-cart-select">
          <span className="shopping-cart-select-text">Selected Shopping Cart:</span>
          <Selectbox
            alignLabel="none"
            label=""
            value={this.props.selectedCart}
            updateAction={this._setSelectedCart}
            options={this.props.availableCarts.map(cart => ({
              name: cart,
              value: cart
            }))}
          />
        </div>
        <div className="shopping-cart-total">
          Total:{' '}
          {currencyFormatter.format(totalPrice, {
            symbol: currency,
            decimal: ',',
            thousand: '.',
            precision: 2,
            format: '%v %s' // %s is the symbol and %v is the value
          })}
        </div>

        {this.props.donotsendorder == '1' ? (
          <button className="shopping-cart-submit is-disabled" type="button" onClick={() => null}>
            {this.props.donotsendorderHtml ? (
              <RenderHTML html={this.props.donotsendorderHtml} />
            ) : (
              'To place the order, please contact the acquisition team'
            )}
          </button>
        ) : (
          Cookies.get('orderpermit') != '0' && (
            <button
              className={`shopping-cart-submit ${
                this.props.items && this.props.items.length > 0 ? '' : 'is-disabled'
              }`}
              type="button"
              onClick={() => {
                if (this.props.items && this.props.items.length > 0) {
                  return this._orderCart();
                } else {
                  return null;
                }
              }}
            >
              Order now
            </button>
          )
        )}
        <div className="shopping-cart-flag">
          <img src="/images/icons/cart.png" aria-hidden="true" alt="Einkaufswagen" />
        </div>
        <div className="shopping-cart-items">
          {this.props.items &&
            this.props.items.map(item => {
              return (
                <ShoppingCartItem
                  key={`${item.isbn}_${item.lfd}`}
                  index={item.lfd}
                  item={item}
                  isbn={item.isbn}
                  title={item.titl}
                  konto={item.knut}
                  budgetCode={item.code}
                  ebrary={item.elic}
                  reference={item.kref}
                  price={item.vkpr && Number(item.vkpr)}
                  currency={item.kdfw}
                  quantity={(item.copy && parseInt(item.copy)) || 1}
                  onRemove={this._removeItem}
                  onUpdateQuantity={this._updateQuantity}
                />
              );
            })}
          {this.props.loading && <div className="shopping-cart-loading">Loading...</div>}
        </div>
        <Modal
          open={this.state.requestRTA}
          onClose={() => {
            this.setState({
              requestRTA: false
            });
          }}
        >
          <h4>
            Please select the fund, library and location <br />
            for each of the following books:
          </h4>
          {this.props.items &&
            this.props.items.map((item, index) => {
              return (
                <div key={item.lfd}>
                  <hr />
                  <h5>
                    {item.titl} <br />
                    <small>ISBN: {item.isbn}</small>
                  </h5>
                  {(!this.state.inheritFromFirst || index === 0) && (
                    <div>
                      <Textfield
                        label="Fund Code"
                        placeholder="Code"
                        required={true}
                        onChange={(currentItem => {
                          return value => {
                            this.setState(prevState => {
                              const rta = {...prevState.rta};
                              if (!rta[currentItem.lfd]) {
                                rta[currentItem.lfd] = {};
                              }
                              rta[currentItem.lfd].isbn = currentItem.isbn;
                              rta[currentItem.lfd].foundCode = value;
                              return {
                                rta
                              };
                            });
                          };
                        })(item)}
                        autocomplete={this.state.rtaFunds.map(fund => fund.code)}
                      />
                      <Selectbox
                        alignLabel="top"
                        label="Library *"
                        required={true}
                        updateAction={(currentItem => {
                          return value => {
                            this.setState(prevState => {
                              const rta = {...prevState.rta};
                              if (!rta[currentItem.lfd]) {
                                rta[currentItem.lfd] = {};
                              }
                              rta[currentItem.lfd].isbn = currentItem.isbn;
                              rta[currentItem.lfd].library = value;
                              rta[currentItem.lfd].location = '';
                              return {
                                rta
                              };
                            });
                          };
                        })(item)}
                        options={this.state.rtaLibraries.map(item => {
                          return {
                            name: `${item.name}`,
                            value: `${item.code}`
                          };
                        })}
                      />
                      {this.state.rta && this.state.rta[item.lfd] && (
                        <Fetch
                          url={`https://rta.delbanco.de/proxy/conf/libraries/${this.state.rta[item.lfd].library}/locations`}
                          addSessionData={false}
                          data={{
                            apikey: this.rtaConfig.apiKey
                          }}
                        >
                          {({data}) => {
                            if (data) {
                              return (
                                <Selectbox
                                  alignLabel="top"
                                  label="Location *"
                                  required={true}
                                  updateAction={(currentItem => {
                                    return value => {
                                      this.setState(prevState => {
                                        const rta = {...prevState.rta};
                                        if (!rta[currentItem.lfd]) {
                                          rta[currentItem.lfd] = {};
                                        }
                                        rta[currentItem.lfd].isbn = currentItem.isbn;
                                        rta[currentItem.lfd].location = value;
                                        return {
                                          rta
                                        };
                                      });
                                    };
                                  })(item)}
                                  options={data.location.map(item => {
                                    return {
                                      name: `${item.name}`,
                                      value: `${item.code}`
                                    };
                                  })}
                                />
                              );
                            }
                            return null;
                          }}
                        </Fetch>
                      )}
                    </div>
                  )}
                  {index === 0 && (
                    <Checkbox
                      onclick={value => {
                        this.setState({
                          inheritFromFirst: value
                        });
                      }}
                      value={false}
                      label="Use this selection for all Books"
                      name="inherit"
                    />
                  )}
                </div>
              );
            })}
          <div className="button-wrapper">
            <Button
              type="danger"
              onClick={() => {
                this.setState({
                  requestRTA: false
                });
              }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={() => this._submitOrderCart()}>
              Order now
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

ShoppingCart.propTypes = {
  loading: React.PropTypes.bool,
  items: React.PropTypes.arrayOf(
    React.PropTypes.shape({
      isbn: React.PropTypes.string,
      lfd: React.PropTypes.string,
      title: React.PropTypes.string,
      author: React.PropTypes.string,
      price: React.PropTypes.number,
      quantity: React.PropTypes.number
    })
  ),
  availableCarts: React.PropTypes.arrayOf(React.PropTypes.string),
  selectedCart: React.PropTypes.string,
  donotsendorder: React.PropTypes.string,
  donotsendorderHtml: React.PropTypes.string,
  orderCart: React.PropTypes.func,
  removeFromCart: React.PropTypes.func,
  updateQuantity: React.PropTypes.func,
  setSelectedCart: React.PropTypes.func,
  getInitialCart: React.PropTypes.func
};

const mapStateToProps = state => {
  return {
    loading: state.cart.loading > 0,
    items: state.cart.cart,
    selectedCart: state.cart.selectedCart,
    availableCarts: state.cart.availableCarts,
    donotsendorder: state.cart.clientInfo.donotsendorder,
    donotsendorderHtml: state.cart.clientInfo.donotsendorderhtml
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getInitialCart: () => {
      dispatch(getInitialCart());
    },
    removeFromCart: item => {
      dispatch(removeFromCart(item));
    },
    updateQuantity: (subaccount, item, quantity) => {
      dispatch(updateQuantity(subaccount, item, quantity));
    },
    orderCart: (additionalAttributes, withRta) => {
      dispatch(orderCart(additionalAttributes, withRta));
    },
    setSelectedCart: cart => {
      dispatch(setSelectedCart(cart));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShoppingCart);



// WEBPACK FOOTER //
// ./src/js/components/shoppingCart/ShoppingCart.js